// src/App.jsx
import { useEffect, useRef, useState } from 'react';
import { BrowserRouter, useNavigate, useLocation } from 'react-router-dom';
import './App.css';

const PROXY_BASE = 'https://us-central1-ux-hassan.cloudfunctions.net/proxy';
// const PROXY_BASE = 'http://127.0.0.1:5002/ux-hassan/us-central1/proxy';
// Path prefix of the proxy (iframe sends full path; we strip this to get Framer route)
const PROXY_PATH_PREFIX = new URL(PROXY_BASE).pathname.replace(/\/$/, '');

function normalizePath(p) {
    if (!p || p === '/') return '/';
    return p.replace(/\/+$/, '') || '/';
}

const FullPageIframe = () => {
    const iframeRef = useRef(null);
    const navigate = useNavigate();
    const location = useLocation();
    const isSyncingFromApp = useRef(false);
    // When we sync URL from iframe we don't update iframe src (avoids reload)
    const lastPathFromIframeRef = useRef(null);
    // Iframe src is state so we only change it when WE drive navigation (e.g. back/forward)
    const [iframeSrc, setIframeSrc] = useState(() => PROXY_BASE + '/');

    // Listen for route messages FROM iframe → update browser URL only
    useEffect(() => {
        const handleMessage = (event) => {
            // Only accept messages from our proxy function
            if (!event.origin.includes('cloudfunctions.net')) return;
            // if (!event.origin.includes('http://127.0.0.1:5002')) return;
            if (event.data?.type !== 'ROUTE_CHANGE') return;

            if (!isSyncingFromApp.current) {
                let newPath = event.data.path;
                if (newPath.startsWith(PROXY_PATH_PREFIX)) {
                    newPath = newPath.slice(PROXY_PATH_PREFIX.length) || '/';
                }
                newPath = normalizePath(newPath);
                const currentNormalized = normalizePath(location.pathname);
                if (newPath !== currentNormalized) {
                    lastPathFromIframeRef.current = newPath;
                    navigate(newPath, { replace: true });
                }
            }
        };

        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, [navigate, location.pathname]);

    // When browser URL changes: only update iframe src when WE drove the change (e.g. back/forward)
    useEffect(() => {
        const currentNormalized = normalizePath(location.pathname);
        const cameFromIframe = currentNormalized === lastPathFromIframeRef.current;

        if (cameFromIframe) {
            // Defer clear so React Strict Mode's second effect run still sees the ref and skips
            setTimeout(() => { lastPathFromIframeRef.current = null; }, 0);
            return; // iframe already navigated; don't touch src
        }

        const targetSrc = PROXY_BASE + location.pathname + (location.search || '');
        setIframeSrc((prev) => {
            if (prev === targetSrc) return prev;
            isSyncingFromApp.current = true;
            setTimeout(() => { isSyncingFromApp.current = false; }, 500);
            return targetSrc;
        });
    }, [location.pathname]);

    return (
        <div style={{ position: 'relative', width: '100vw', height: '100vh' }}>
            <iframe
                ref={iframeRef}
                src={iframeSrc}
                style={{ width: '100%', height: '100%', border: 'none' }}
                title="UX Hassan"
            />
        </div>
    );
};

function App() {
    return (
        <BrowserRouter>
            <div className="App">
                <FullPageIframe />
            </div>
        </BrowserRouter>
    );
}

export default App;
